import * as Sentry from '@sentry/react';

Sentry.init({
	enabled: process.env.NODE_ENV === 'production',
	dsn: 'https://4c36f4b759f91aab0db8843bf8196861@o240489.ingest.us.sentry.io/4508301428785152',
	integrations: [
		Sentry.browserTracingIntegration(),
		Sentry.replayIntegration(),
	],
	// Tracing
	tracesSampleRate: 1.0, //  Capture 100% of the transactions
	// Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
	tracePropagationTargets: ['localhost', 'https://myaccount.japan-expo.com'],
	// Session Replay
	replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
	replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});